import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationValuation {
    static URL = UrlConstants.API_V2 + "PropertyValuationValuation";
    static FUNCTION_SET_STATUS = "SetStatus";
    static FUNCTION_ACCEPT_VALUATION = "AcceptValuation";
    static FUNCTION_ACCEPT_MULTIPLE_VALUATION = "AcceptMultipleValuation";
    static FUNCTION_REJECT_VALUATION = "RejectValuation";
    static FUNCTION_HISTORIC_VALUE_CAPTURE = "HistoricValueCapture";
    static FUNCTION_CSV_HISTORIC_VALUE_CAPTURE = "CsvHistoricValueCapture";
    static FUNCTION_CREATE_VALUATION = "CreateNewValuation";
    static FUNCTION_GET_COMPARABLE_SALES_DATA = "GetComparableSalesData";
    static FUNCTION_GET_PVMACP_COMPARABLE_SALES_DATA = "GetPvMaCpComparableSalesData";
    static FUNCTION_UPDATE_COMPARABLE_SALES_DATA = "UpdateSalesData";
    static FUNCTION_UPDATE_PVMACP_COMPARABLE_SALES_DATA = "UpdatePvMaCpComparableSalesData";
}
